export default {
  message: {
    navigation:'return to merchant',
    heard:'Awaiting Payment',
    orderTitle:'order amount',
    exchangeRate :'exchange rate',
    PleaseOne: 'Please only send',
    PleaseTwo: 'coins to this address on the',
    PleaseThree: 'network',
    Amount:'Amount',
    wallerAddress:'Wallet address',
    error: 'Payment timed out, order closed',
    errorTitle: 'Your order has timed out, please try again!',
    succeed: 'Payment successful',
    succeedTitle: "You can view the order in the order list!",
    payNumber:'Amount',
    repayNumber: 'Actual payment amount',
    orderAmount:'Order amount',
    orderId:'Order Number',
    meassage:"Copy Success",
    Nodata:'No Data',
    OrderError:'Order Error',
    verification:'order_id verification failed,please contact the merchant for processing',
  }, 
}

